export function csrfToken(): string {
  return document.cookie.split("; ").find((row) => row.startsWith("ep_csrf="))?.split("=").slice(1).join("=") ?? "";
}

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const method = init.method?.toUpperCase() ?? "GET";
  const headers = new Headers(init.headers);
  if (method !== "GET" && method !== "HEAD") headers.set("X-CSRF-Token", decodeURIComponent(csrfToken()));
  if (init.body) headers.set("Content-Type", "application/json");
  const response = await fetch(path, { ...init, headers, credentials: "same-origin" });
  if (!response.ok) throw new Error((await response.json().catch(() => ({}))).error ?? `Request failed: ${response.status}`);
  return response.json() as Promise<T>;
}

